import { render, staticRenderFns } from "./SupplementsAdminPage.vue?vue&type=template&id=10fb804f&scoped=true"
import script from "./SupplementsAdminPage.vue?vue&type=script&lang=js"
export * from "./SupplementsAdminPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fb804f",
  null
  
)

export default component.exports